import LangSwitcher from "./LangSwitcher.vue";

export { LangSwitcher };
